<mat-list class="date">

        <h3 mat-subheader>
            <span>Today</span>
        </h3>

        <div class="secondary-text mat-display-1 mb-0 p-16">
            <div class="mb-12">
                {{date | date:'EEEE'}}
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <span> {{date | date:'d'}}</span>
                <span class="mat-subheading-1">th</span>
                <span> {{date | date:'MMMM'}}</span>
            </div>
        </div>
    </mat-list>

    <mat-divider></mat-divider>
    <mat-list>
        <h3 mat-subheader>
            <span>Alerts</span>
        </h3>

        <mat-list-item *ngFor="let event of events">
            <h3 mat-line>{{event.title}}</h3>
            <p mat-line class="secondary-text">{{event.detail}}</p>
        </mat-list-item>
    </mat-list>



// WEBPACK FOOTER //
// ./src/app/main/shared/components/quick-panel/quick-panel.component.html